import Utils from "../../../utils";

// Turns a notification's stored params into the values its i18n string interpolates.
//
// The server never stores rendered text - names travel as their whole name/name2/name3 triplets
// so the same row reads correctly in tk, ru and en. Resolution happens here, at render time,
// against whichever language the reader has selected.

const buildValues = (params) => {
    if (!params) return {};

    const values = { ...params };

    if (params.employee) values.employee = Utils.getLocalizedFullName(params.employee);
    if (params.actor) values.actor = Utils.getLocalizedFullName(params.actor);
    if (params.leaveType) values.leaveType = Utils.getLocalizedName(params.leaveType);
    if (params.department) values.department = Utils.getLocalizedName(params.department);
    if (params.startDate) values.startDate = Utils.getTimestampDate(params.startDate);
    if (params.endDate) values.endDate = Utils.getTimestampDate(params.endDate);

    return values;
}

// i18n key per notification type. A type with no translation falls back to its own name rather
// than rendering blank, which makes a missing key obvious in review instead of invisible.
export const notificationMessage = (notification, t) => {
    const key = `NOTIF_${notification?.type}`;
    const text = t(key, buildValues(notification?.params));
    return text === key ? notification?.type : text;
}

export const notificationReason = (reason, t) => {
    const key = `NOTIF_REASON_${reason}`;
    const text = t(key);
    return text === key ? '' : text;
}

export default notificationMessage;
